// @flow
export default function waitForAnalytics(callback: () => void) {
  if (!window.analytics) return setTimeout(() => waitForAnalytics(callback), 300)

  window.analytics.ready(callback)
}
